var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { apiEndpoints } from '../../app.constants';
import 'rxjs/add/operator/map';
import { BackendHttpService } from '../../core/backend-http.service';
import { StringUtils } from '../../utils/string.utils';
import { BlockedReason, WallType } from '../../../models/user';
var InfluencerGroupsService = /** @class */ (function (_super) {
    __extends(InfluencerGroupsService, _super);
    function InfluencerGroupsService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfluencerGroupsService.prototype.getInfluencerGroups = function (companyId) {
        var apiUrl = apiEndpoints.groups;
        var params = {
            companyId: companyId
        };
        return this.get(apiUrl, params).map(function (res) { return res ? res.data : null; });
    };
    InfluencerGroupsService.prototype.getInfluencerGroupShortList = function (companyId) {
        var apiUrl = apiEndpoints.influencerGroupShortList;
        var params = {
            companyId: companyId
        };
        return this.get(apiUrl, params).map(function (res) { return res ? res.data : []; });
    };
    InfluencerGroupsService.prototype.createInfluencerGroup = function (postData) {
        return this.post(apiEndpoints.addNewInfluencerGroup, JSON.stringify(postData));
    };
    InfluencerGroupsService.prototype.deleteInfluencerGroup = function (influencerGroupId) {
        return this.post(apiEndpoints.deleteInfluencerGroup, JSON.stringify({ id: influencerGroupId }));
    };
    InfluencerGroupsService.prototype.validateGroup = function (newGroup) {
        var errors = [];
        if (!newGroup.influencerGroupName || StringUtils.trim(newGroup.influencerGroupName) === '') {
            errors.push({
                name: 'group_name',
                message: this.translate.instant('group_influencers.group_name_mandatory')
            });
        }
        return errors;
    };
    InfluencerGroupsService.prototype.extractLimitInfoFromErrorMessage = function (errorMsg, numberAddedItem, maxValue, isCamapaign) {
        var numb = errorMsg.match(/\d+/g);
        if (numb.length === 1) {
            return {
                blockedReason: BlockedReason.ACCOUNT_WALL,
                wallType: WallType.USAGE_LIMIT,
                wallName: isCamapaign ? 'Campaign Limit' : 'Group Limit',
                maxValue: maxValue,
                desiredValue: maxValue + numberAddedItem
            };
        }
        else {
            return {
                blockedReason: BlockedReason.ACCOUNT_WALL,
                wallType: WallType.USAGE_LIMIT,
                wallName: isCamapaign ? 'Selection Limit Campaigns' : 'Selection Limit Groups',
                maxValue: maxValue,
                desiredValue: Number(numb[0]) + (maxValue - Number(numb[1]))
            };
        }
    };
    InfluencerGroupsService.prototype.searchGroupByTerm = function (companyId, searchTerm) {
        var data = {
            companyId: companyId,
            searchValue: searchTerm
        };
        return this.get(apiEndpoints.searchGroups, data).map(function (res) { return res ? res.data : []; });
    };
    InfluencerGroupsService.prototype.uploadBulkInfluencer = function (influencerGroupId, bulkUploadInfluencerData) {
        return this.post(apiEndpoints.bulkUploadInfluencer.replace(':influencerGroupId', influencerGroupId.toString()), JSON.stringify(bulkUploadInfluencerData))
            .map(function (res) { return res; });
    };
    return InfluencerGroupsService;
}(BackendHttpService));
export { InfluencerGroupsService };



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/influencer-groups.service.ts.pre-build-optimizer.js